<template>
  <div class="recommendPage">
    <swiper :options="swiperOption" ref="mySwiper">
      <swiper-slide>
        <div class="transBak"></div>
        <div class="text_contet">
          <div class="text_content_child">
            <a style="font-size: 80px;color: #ffbc42;font-weight: normal">必 胜 课</a>
            <a style="font-size: 40px;margin-top: 75px">人 人 都 在 学</a>
            <a style="font-size: 20px;margin-top: 75px">国内公职在线教育一站式服务平台</a>
            <div style="font-size: 20px;margin-top: 50px">
              <a>成立</a>
              <a style="color: #ffbc42;font-weight: 333;font-size: 40px">{{ localTime }}</a>
              <a>天，累计服务学员已超过</a>
              <a style="color: #ffbc42;font-weight: 333;font-size: 40px">300000+</a>
            </div>
          </div>
        </div>
        <img class="bakimg" src="../../common/images/bak04.jpeg">
      </swiper-slide>
      <swiper-slide>
        <div class="transBak"></div>
        <div class="text_contet">
          <div class="text_content_child2">
            <a style="font-size: 40px">公司</a>
            <a style="font-size: 40px;margin-top: 30px;color: #ffbc42">简介</a>
            <a style="font-size: 20px;margin-top: 30px">COMPANY</a>
            <a style="font-size: 20px;margin-top: 10px">PROFILE</a>
          </div>
          <a style="font-size: 20px;margin-right: 50px;line-height: 30px;text-align: left;margin-left: 50px">必胜课教育成立于2015年9月，是国内最早进入公职在线教育的公司之一，2016年9月天使轮获得投资，在全国有2个全资子公司，1个培训学校，5大战略合作机构，10个全国区域加盟。
            必胜课教育是公职在线教育的新兴品牌，拥有公职教育排名前三的国家级网站，职业教育排名第一的微信公众大号，拥有行业唯一的公职备考一站式saas服务平台“必胜公考APP”。2019年被评为国家五星级信用企业。
          </a>
        </div>
        <img class="bakimg" src="../../common/images/bak05.jpeg">
      </swiper-slide>
      <swiper-slide>
        <div class="transBak"></div>
        <div class="text_contet">
          <div class="text_content_child2">
            <a style="font-size: 40px">公司</a>
            <a style="font-size: 40px;margin-top: 30px;color: #ffbc42">领导</a>
            <a style="font-size: 20px;margin-top: 30px">COMPANY</a>
            <a style="font-size: 20px;margin-top: 10px">LEADERSHIP</a>
          </div>
          <div style="display: flex;flex-direction: row;margin-left: auto;margin-right: 100px">
            <div style="display: flex;flex-direction:column">
              <img width="250px" height="425px" src="../../common/images/zhaoxin.png"
                   style="border: 2px solid #ffbc42;border-radius: 8px">
              <a style="color: #ffbc42;font-size: 20px;margin-top: 20px;font-weight: bold">创始人</a>
              <a style="margin-top: 20px">南开大学硕士</a>
              <a style="margin-top: 10px">百川教育创始人兼董事长(考研)</a>
              <a style="margin-top: 10px">社科赛斯教育联合创始人(专硕)</a>
            </div>
            <div style="width: 50px"/>
            <div style="display: flex;flex-direction:column;">
              <img width="250px" height="425px" style="object-fit: cover;border: 2px solid #ffbc42;border-radius: 8px"
                   src="../../common/images/guanlili.png">
              <a style="color: #ffbc42;font-size: 20px;margin-top: 20px;font-weight: bold">CEO</a>
              <a style="margin-top: 20px">北京理工大学硕士</a>
              <a style="margin-top: 10px">铃兰投资创始人</a>
              <a style="margin-top: 10px">原国美地产、嘉德集团、</a>
              <a style="margin-top: 10px">当代集团成本负责人</a>
            </div>
            <div style="width: 50px"/>
            <div style="display: flex;flex-direction:column">
              <img width="250px" height="425px" src="../../common/images/xiazhiquan.png"
                   style="border: 2px solid #ffbc42;border-radius: 8px">
              <a style="color: #ffbc42;font-size: 20px;margin-top: 20px;font-weight: bold">联合创始人</a>
              <a style="margin-top: 20px">北京大学MBA</a>
              <a style="margin-top: 10px">原阿里巴巴资深 专家</a>
              <a style="margin-top: 10px">原优酷土豆产品技术总监</a>
            </div>
          </div>
        </div>
        <img class="bakimg" src="../../common/images/bak07.jpeg">
      </swiper-slide>
      <swiper-slide>
        <div class="transBak"></div>
        <div class="text_contet">
          <div class="text_content_child2">
            <a style="font-size: 40px">公司</a>
            <a style="font-size: 40px;margin-top: 30px;color: #ffbc42">文化</a>
            <a style="font-size: 20px;margin-top: 30px">COMPANY</a>
            <a style="font-size: 20px;margin-top: 10px">CULTURE</a>
          </div>
          <div class="text_content_child3">
            <a style="font-size: 40px;margin-top: 30px;color: #ffbc42;text-align: left">企业使命</a>
            <a style="font-size: 20px;margin-top: 30px;padding-left: 50px;text-align: left">天下为公 教育必胜</a>
            <a style="font-size: 40px;margin-top: 60px;color: #ffbc42;text-align: left">企业愿景</a>
            <a style="font-size: 20px;margin-top: 30px;padding-left: 50px;text-align: left">助力就业 推动社会进步</a>
            <a style="font-size: 40px;margin-top: 60px;color: #ffbc42;text-align: left">企业价值观</a>
            <a style="font-size: 20px;margin-top: 30px;padding-left: 50px;text-align: left">员工可依赖 利益可共享</a>
            <a style="font-size: 20px;margin-top: 30px;padding-left: 50px;text-align: left">用户有价值 社会有贡献</a>
            <a style="font-size: 40px;margin-top: 60px;color: #ffbc42;text-align: left">教育理念</a>
            <a style="font-size: 20px;margin-top: 30px;padding-left: 50px;text-align: left">树立正确就业观 提升用户素养</a>
            <a style="font-size: 20px;margin-top: 30px;padding-left: 50px;text-align: left">提倡家国情怀 为人民服务</a>
          </div>
        </div>
        <img class="bakimg" src="../../common/images/bak06.jpeg">
      </swiper-slide>
      <swiper-slide>
        <div class="transBak"></div>
        <div class="text_contet">
          <div class="text_content_child2">
            <a style="font-size: 40px">公司</a>
            <a style="font-size: 40px;margin-top: 30px;color: #ffbc42">优势</a>
            <a style="font-size: 20px;margin-top: 30px">COMPANY</a>
            <a style="font-size: 20px;margin-top: 10px">ADVANTAGE</a>
          </div>
          <div
            style="margin-left: auto;margin-right: 100px;display: flex;flex-direction: column;margin-top: auto;margin-bottom: 50px">
            <a style="font-size: 20px;margin-top: 20px">出版了两本公务员考试行测、申论标准教材</a>
            <a style="font-size: 20px;margin-top: 20px">获得了4项行测、申论思维导图等作品著作权</a>
            <a style="font-size: 20px;margin-top: 20px">先后获得了17项网站及APP等产品的软件著作权</a>
            <img style="height: 400px;width:800px;margin-top: 40px;border-radius: 8px;border: 2px solid #ffbc42"
                 src="../../common/images/zhuanli.png">
          </div>
        </div>
        <img class="bakimg" src="../../common/images/bak02.jpeg">
      </swiper-slide>
      <swiper-slide>
        <div class="transBak"></div>
        <div class="text_contet">
          <div class="text_content_child2">
            <a style="font-size: 40px">公司</a>
            <a style="font-size: 40px;margin-top: 30px;color: #ffbc42">荣誉</a>
            <a style="font-size: 20px;margin-top: 30px">COMPANY</a>
            <a style="font-size: 20px;margin-top: 10px">HONOR</a>
          </div>
          <div>
            <img style="width: 300px;height: 200px;border-radius: 8px;border: 2px solid #ffbc42"
                 src="../../common/images/honor1.png">
            <img style="width: 300px;height: 200px;margin-left: 20px;border-radius: 8px;border: 2px solid #ffbc42"
                 src="../../common/images/honor2.png">
            <img style="width: 300px;height: 200px;margin-left: 20px;border-radius: 8px;border: 2px solid #ffbc42"
                 src="../../common/images/honor3.png">
            <img style="width: 300px;height: 200px;margin-top: 50px;border-radius: 8px;border: 2px solid #ffbc42"
                 src="../../common/images/honor4.png">
            <img
              style="width: 300px;height: 200px;margin-top: 50px;margin-left: 20px;border-radius: 8px;border: 2px solid #ffbc42"
              src="../../common/images/honor5.png">
          </div>
        </div>
        <img class="bakimg" src="../../common/images/bak01.jpeg">
      </swiper-slide>
      <swiper-slide>
        <div class="transBak"></div>
        <div class="text_contet">
          <div class="text_content_child">
            <a style="font-size: 40px;font-weight: normal">上岸之路并不孤单</a>
            <a style="font-size: 60px;margin-top: 75px;color: #ffbc42;">必胜课助您早日成公！</a>
          </div>
        </div>
        <img class="bakimg" src="../../common/images/bak03.jpeg">
      </swiper-slide>
    </swiper>
    <div class="swiper-pagination" slot="pagination"></div>
  </div>
</template>

<script>
// 引入插件
import {swiper, swiperSlide} from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

export default {
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      swiperOption: {
        direction: 'vertical',
        slidesPerView: 1,
        spaceBetween: 0,
        mousewheel: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      },
      localTime: "",
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  mounted() {
    // current swiper instance
    // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
    console.log("this is current swiper instance object", this.swiper);
    // this.swiper.slideTo(3, 1000, false);
    this.DateDiff()
  },
  methods: {
    DateDiff: function () {    //sDate1和sDate2是2006-12-18格式
      var aDate1 = Date.parse(new Date("2015-09-01 08:00"));
      var aDate2 = new Date;
      var iDays = (aDate2.getTime() - aDate1) / (1000 * 3600 * 24);
      console.log(iDays, 'ts');
      this.localTime = Math.trunc(iDays);
    }
  }
};
</script>
<style scoped>
.recommendPage .swiper-container {
  width: 100%;
  height: 700px;
  margin-bottom: -30px;
}

.recommendPage .swiper-container .swiper-slide {
  width: 100%;
  line-height: 100%;
  color: #000;
  font-size: 16px;
  text-align: center;
  position: relative;
}

.transBak {
  position: absolute;
  background: rgba(0, 0, 0, 0.5);
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

.bakimg {
  height: 100%;
  width: 100%;
}

.swiper-pagination {
  top: 40%;
  background-color: #ccc;
  opacity: 0.5;
  padding-left: 10px;
  padding-right: 10px;
  width: 10px;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}

.text_contet {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  color: #FFEBCD;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

.text_content_child {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.text_content_child2 {
  margin-left: 100px;
  display: flex;
  flex-direction: column;
}

.text_content_child3 {
  display: flex;
  flex-direction: column;
  margin-left: auto;
  margin-right: 200px;
}
</style>




// WEBPACK FOOTER //
// src/components/Layout/Introduce.vue